var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('td',{staticClass:"min"},[_vm._v(_vm._s(_vm.place)+".")]),_c('td',{staticClass:"nickname"},[_vm._v(_vm._s(_vm.user.nickname))]),_c('td',[_vm._v("$"+_vm._s(_vm.dollars))]),_c('td',{staticClass:"min"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }